import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText } from '@mui/material';
import { Alert } from '@mui/material';

const DeleteSignUpFormDomainDialog = ({ domain, onSubmit, onCancel }) => {
    return (
        <Dialog
            open={true}
            onClose={onCancel}
            maxWidth="sm"
        >
            <DialogTitle>Delete Domain</DialogTitle>
            <DialogContent dividers>
                <Alert severity="error" sx={{ marginBottom: 2 }}>
                    You are about to delete the domain <strong>{domain}</strong>. This means sign-up form submissions from this domain will no longer be allowed.
                </Alert>
                <DialogContentText>
                    Are you sure you want to proceed?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} variant="outlined">Cancel</Button>
                <Button onClick={onSubmit} color="error">Delete Domain</Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteSignUpFormDomainDialog;